
import React from 'react'
import propTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import {default as MuiPaper} from '@material-ui/core/Paper'


const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    marginBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
  }
})

const Paper = ({children, classes, ...rest}) => (
  <MuiPaper classes={{...classes}} {...rest}>
    {children}
  </MuiPaper>
)

Paper.propTypes = {
  children: propTypes.element
}

export default withStyles(styles)(Paper)


// WEBPACK FOOTER //
// ./src/components/counseling-session/StyledPaper.js